import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(location.hash.replace("#", "")).get("session_id");
    const exchange = async () => {
      try {
        const { data } = await axios.post(
          `${API}/auth/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );
        navigate("/admin", { state: { user: data.user }, replace: true });
      } catch (e) {
        const status = e.response?.status;
        navigate(`/admin/login?error=${status === 403 ? "unauthorized" : "failed"}`, { replace: true });
      }
    };
    exchange();
  }, [location, navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-ivory" data-testid="auth-callback-loading">
      <p className="font-mono text-xs uppercase tracking-[0.3em] text-sage">Signing you in…</p>
    </div>
  );
}
